import { styled } from '@mui/material/styles';
import {
  TableContainer,
  Table,
  TableCell,
  TableRow,
  Button,
  Box,
} from '@mui/material';

export const TableWrapper = styled(Box)<{ maxWidth?: string }>(({ theme, maxWidth }) => ({
  minHeight: '200px',
  padding: '24px',
  background: 'white',
  borderRadius: '6px',
  boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.08)',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  height: '100%',
  maxWidth: maxWidth || '100%',
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
    gap: '16px',
    minHeight: 'unset',
  },
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: '8px',
  border: '1px solid #E0E0E0',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#FFFFFF',
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '4px',
  },
}));

export const StyledTable = styled(Table)({
  minWidth: 650,
  borderCollapse: 'separate',
  borderSpacing: 0,
});

export const StyledHeaderCell = styled(TableCell)(({ theme }) => ({
  padding: '8px 12px',
  background: '#E7EFF5 !important',
  borderRadius: '4px',
  fontFamily: "'Lato', sans-serif",
  fontSize: '12px',
  fontWeight: 700,
  color: 'rgba(0, 0, 0, 0.8)',
  textAlign: 'center',
  border: 'none',
  position: 'sticky',
  top: 0,
  zIndex: 10,
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  '&:first-of-type': {
    paddingLeft: '16px',
  },
  '&:last-of-type': {
    paddingRight: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '11px',
    padding: '6px 8px',
    '&:first-of-type': {
      paddingLeft: '12px',
    },
    '&:last-of-type': {
      paddingRight: '12px',
    },
  },
}));

export const StyledBodyCell = styled(TableCell)(({ theme }) => ({
  padding: '8px 12px',
  background: 'transparent',
  fontFamily: "'Lato', sans-serif",
  fontSize: '12px',
  fontWeight: 400,
  color: 'rgba(0, 0, 0, 0.8)',
  textAlign: 'center',
  borderBottom: '1px solid #E0E0E0',
  '&:first-of-type': {
    paddingLeft: '16px',
  },
  '&:last-of-type': {
    paddingRight: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '11px',
    padding: '6px 8px',
    '&:first-of-type': {
      paddingLeft: '12px',
    },
    '&:last-of-type': {
      paddingRight: '12px',
    },
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:hover': {
    backgroundColor: '#fafafa',
  },
  '&:last-child td': {
    borderBottom: 'none',
  },
  '&.alternate': {
    backgroundColor: '#f5f5f5',
  },
}));

export const PaginationButton = styled(Button)(({ theme }) => ({
  padding: '8px 16px',
  border: '1px solid #1A1A1A',
  borderRadius: '4px',
  color: 'rgba(0, 0, 0, 0.8)',
  fontSize: '14px',
  fontFamily: "'Lato', sans-serif",
  textTransform: 'none',
  minWidth: 'unset',
  [theme.breakpoints.down('sm')]: {
    padding: '4px 8px',
    fontSize: '12px',
  },
}));

export const ShowAllButton = styled(Button)(({ theme }) => ({
  height: '28px',
  padding: '0 24px',
  background: '#E7EFF5',
  borderRadius: '9999px',
  fontSize: '12px',
  fontWeight: 700,
  fontFamily: "'Lato', sans-serif",
  textTransform: 'uppercase',
  color: '#1A1A1A',
  '&:hover': {
    background: '#d0e0ed',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
    fontSize: '11px',
    height: '24px',
    whiteSpace: 'nowrap',
  },
})); 